import React, { useEffect } from 'react';

import styled, { css } from 'styled-components';

import { IBaseProps, OnClick } from '@rbi-ctg/frontend';
import usePreventBodyScroll from 'hooks/use-prevent-body-scroll';
import { useAccessibility } from 'state/accessibility';

import Header from './header';

const FullPageContainer = styled.div`
  position: fixed;
  display: grid;

  z-index: ${Styles.zIndex.overlay + 100};
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  -webkit-overflow-scrolling: touch;

  overflow: hidden;
  ${Styles.desktop`
    overflow-y: auto;
  `}
`;

/* This ContainerWrapper is needed in order to fix the issue explained here: https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
  i.e. Because the viewport height are not the same on mobile browser... */
const ContainerWrapper = styled.div`
  position: relative;
  height: 100%;
  min-height: 100%;
`;

const Container = styled.section<{ $shouldRemoveOverflow?: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: ${Styles.color.background};
  display: flex;
  flex: 1;
  ${props =>
    !props.$shouldRemoveOverflow
      ? css`
          overflow: scroll;
          overflow-y: auto;
          overflow-x: visible;
        `
      : css`
          overflow-y: hidden;
        `}
  ${Styles.desktop`
    top: ${Styles.layout.checkoutHeaderHeight};
  `}
`;

export interface IFullPageScreenProps extends IBaseProps {
  heading: string;
  closeHref?: string;
  onClose?: OnClick;
  disableClose?: boolean;
  removeOverflow?: boolean;
  skipGoBackOnClose?: boolean;
}

const FullPageScreen = ({
  className,
  children,
  heading,
  closeHref,
  onClose,
  disableClose,
  removeOverflow,
  skipGoBackOnClose = false,
}: IFullPageScreenProps) => {
  const { setFullPageModalActive } = useAccessibility();
  usePreventBodyScroll();

  useEffect(() => {
    setFullPageModalActive(true);
    return () => setFullPageModalActive(false);
  }, [setFullPageModalActive]);

  return (
    <FullPageContainer className={className}>
      <Header
        closeHref={closeHref}
        heading={heading}
        onClose={onClose}
        disableClose={disableClose}
        skipGoBackOnClose={skipGoBackOnClose}
      />
      <ContainerWrapper>
        <Container $shouldRemoveOverflow={removeOverflow}>{children}</Container>
      </ContainerWrapper>
    </FullPageContainer>
  );
};

export default FullPageScreen;
